// Module
var code = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7.38 20.626a1.285 1.285 0 010-1.825l6.56-6.57a.322.322 0 000-.462l-6.56-6.57a1.286 1.286 0 011.81-1.825l7.252 7.263a1.943 1.943 0 010 2.726L9.19 20.626a1.283 1.283 0 01-1.81 0z\" fill=\"currentColor\"/></svg>";
// Exports
module.exports = code;